<template>
	<div class="app">
		<div class="loading" v-if="loading">
			<div class="spinner">
				<div class="spinner-container container1">
					<div class="circle1"></div>
					<div class="circle2"></div>
					<div class="circle3"></div>
					<div class="circle4"></div>
				</div>
				<div class="spinner-container container2">
					<div class="circle1"></div>
					<div class="circle2"></div>
					<div class="circle3"></div>
					<div class="circle4"></div>
				</div>
				<div class="spinner-container container3">
					<div class="circle1"></div>
					<div class="circle2"></div>
					<div class="circle3"></div>
					<div class="circle4"></div>
				</div>
			</div>
		</div>
		<div v-else>
			<!-- 未登录 -->
			<vip-login :pageZoom='pageZoom' v-if="!loginIs"></vip-login>
			<!-- 非会员 -->
			<vip-no :pageZoom='pageZoom' v-else-if="loginIs && vipState===0 && cvipMes" :card-state="cardState" :vipState="vipState"></vip-no>
			<vip v-else-if="loginIs && (vipState===1 || vipState===10) && cvipMes" :vipState="vipState" :card-state="cardState"></vip>
			<vip-expir v-else-if="loginIs && vipState===2 && cvipMes" :vipState="vipState"></vip-expir>
		</div>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import * as types from '../../store/mutation-types.js'
	import {
		getUserMes,
		getCvipinfo,
		getCvipMain,
		getEnterCvip,
		getinsurance,
		getAccidentInsuranceState,
		getPrice,
		getResumeHighlight
	} from '../../api/index.js'
	// 非会员
	import VipLogin from './app/VipLoginNo.vue';
	import Vip from './app/Vip.vue';
	// 未登录
	import VipNo from './app/VipNo.vue';
	// 过期会员
	import VipExpir from './app/VipExpir.vue';

	export default {
		name: 'app',
		components: {
			VipLogin,
			Vip,
			VipNo,
			VipExpir
		},
		data() {
			return {
				vipState: '',
				cardState: 0,
				pageZoom: false,
				loading: true
			}
		},
		created() {
			this.changeZoom();
			this.getUserMesFn() //获取会员状态
			this.getEnterCvipFn(this.fromSource);
			this.getMealInfo();
		},
		methods: {
			getUserMesFn() {
				// 求职会员状态
				getUserMes().then((result) => {
					if (result.isSuccess) {
						if (!result.entity) {
							this.$store.commit('IS_LOGIN', false)
							window.clickLog && window.clickLog(`from=pc-cvip-shouyeshow-${1}-new`);
							// 加载完成
							this.loading = false;
							return
						}
						this.$store.commit('IS_LOGIN', true)
						// 保存用户信息（名称 & 头像）
						this.$store.commit('USER_INFO', {
							nickname: result.entity.nickname,
							profile: result.entity.profile
						})
						this.getCvipinfoFn()
						this.getCvipMainFn('pc')
						this.getInsurance(); //求职保障险首页状态数据
						this.getAccidentInsuranceState(); //投保状态
						this.getResumeHighlightFn('pc', 5);
					}
				}).catch((err) => {
					console.error('网络异常-------------getUserMes')
				})
			},
			getCvipinfoFn() {
				// 求职会员状态
				getCvipinfo().then((result) => {
					if (result.isSuccess) {
						// this.vipState = 1;
						// 0-未开通  1-使用中   2-已过期
						this.vipState = result.entity.state
						this.cardState = result.entity.cardState || 1
						//非会员情况下改变html body样式
						window.clickLog && window.clickLog(`from=pc-cvip-shouyeshow-${this.vipState}-new`);
						// 加载完成
						this.loading = false;
					} else {
						console.log('网络异常---------getCvipinfo----result')
					}
				}).catch((err) => {
					console.error('网络异常-------------getCvipinfoFn')
				})
			},
			getCvipMainFn(ft) {
				// 求职会员首页所有信息
				getCvipMain(ft).then((result) => {
					if (result.isSuccess) {
						this.$store.commit({
							type: types.CHANGE_CVIP_MES,
							state: result.entity
						})
						if(result.entity.advice) {
							this.$store.commit('RIGHT_USED', result.entity.advice.resourceUsedResult.resourceUsedMap)
						}
						this.$store.commit('LEFT_TOP', result.entity.leftTop);
						// 是否为续费状态
						this.$store.commit('RENEW_STATE', result.entity.renew);
					} else {
						console.log('网络异常-----------getCvipMain----result')
					}
				}).catch((err) => {
					console.log('网络异常-----------getCvipMain')
				})
			},
			getInsurance() { // 求职保障险首页状态数据  新版会员 || 老版会员
				getinsurance().then(result => {
					this.$store.commit('CVIP_STATE', result)
				}).catch((err) => {
					console.log('网络异常')
				})
			},
			getAccidentInsuranceState() {
				getAccidentInsuranceState().then(result => {
					if (result.isSuccess) {
						this.$store.commit('INSURANCE_STATE', result)
					} else {
						console.log('网络异常')
					}
				}).catch(err => {
					console.log('网络异常')
				})
			},
			/**
			 * 统计入口来源
			 */
			getEnterCvipFn (from) {
					getEnterCvip(from).then((res) => {
						console.log('********** 记录入口 **********')
					}).catch((err) => {
						console.log('网络异常')
					})
			},
			//缩放判断     大部分在1366 和 1440
			changeZoom(){
				if(outerWidth <= 1440){
					this.pageZoom = true;
				}
			},
			/**
			 * 获取简历数量
			 * 简历置顶（productid=5） or 黄金亮点（productid=4）
			 */
			getResumeHighlightFn(ft, productid) {
				getResumeHighlight(ft, productid).then((result) => {
					if (result.isSuccess) {
						let num = (result.entity && result.entity.resumes) ? result.entity.resumes.length : 0
						this.$store.commit('RESUME_NUM', num)
					} else {
						console.log('网络异常')
					}
				}).catch((err) => {
					console.log('网络异常 --------- getResumeHighlightFn')
				})
			},
			// 获取套餐信息
			getMealInfo() {
				getPrice().then(result => {
					if(result.isSuccess) {
						this.$store.commit('MEAL_INFO', result.entity);
					} else {
						console.error('网络异常-----result-----getprice');
					}
				}).catch(err => {
					console.log('网络异常-------getprice');
				})
			}
		},
		computed: {
			...mapGetters({
				cvipMes: 'cvipMes',
				loginIs: 'loginIs',
				fromSource: 'fromSource',
			}),
		}

	}
</script>

<style lang="scss" scope>
	@import "../../assets/css/reset.scss";
	.vip-browser-outdated {
		position: fixed;
		z-index: 999999;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		opacity: 0.9;
		border-bottom: 2px solid #f1e2bc;
		background-color: #000;
		filter: alpha(opacity=90);
		_position: absolute;
		_height: 13100px;
		font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
		"Microsoft YaHei", Arial, sans-serif, "微软雅黑";
	}

	.vip-browser-outdated p {
		font-size: 20px;
		line-height: 40px;
		height: 40px;
		padding-top: 20px;
		text-align: center;
		color: #504c2d;
		background: #faf1da;
	}

	// 加载中的样式
	.loading{
		position: fixed;
		left: 0;
		right: 0;
		background: #fff;
		width: 100%;
		height: 100%;
		.spinner {
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translateX(-50%) translateY(-50%);
			width: 70px;
			height: 70px;
		}
		.container1 > div, .container2 > div, .container3 > div {
			width: 20px;
			height: 20px;
			background-color: #333;
			border-radius: 100%;
			position: absolute;
			-webkit-animation: bouncedelay 1.2s infinite ease-in-out;
			animation: bouncedelay 1.2s infinite ease-in-out;
			-webkit-animation-fill-mode: both;
			animation-fill-mode: both;
		}

		.spinner .spinner-container {
			position: absolute;
			width: 100%;
			height: 100%;
		}

		.container2 {
			-webkit-transform: rotateZ(45deg);
			transform: rotateZ(45deg);
		}

		.container3 {
			-webkit-transform: rotateZ(90deg);
			transform: rotateZ(90deg);
		}

		.circle1 { top: 0; left: 0; }
		.circle2 { top: 0; right: 0; }
		.circle3 { right: 0; bottom: 0; }
		.circle4 { left: 0; bottom: 0; }

		.container2 .circle1 {
			-webkit-animation-delay: -1.1s;
			animation-delay: -1.1s;
		}

		.container3 .circle1 {
			-webkit-animation-delay: -1.0s;
			animation-delay: -1.0s;
		}

		.container1 .circle2 {
			-webkit-animation-delay: -0.9s;
			animation-delay: -0.9s;
		}

		.container2 .circle2 {
			-webkit-animation-delay: -0.8s;
			animation-delay: -0.8s;
		}

		.container3 .circle2 {
			-webkit-animation-delay: -0.7s;
			animation-delay: -0.7s;
		}

		.container1 .circle3 {
			-webkit-animation-delay: -0.6s;
			animation-delay: -0.6s;
		}

		.container2 .circle3 {
			-webkit-animation-delay: -0.5s;
			animation-delay: -0.5s;
		}

		.container3 .circle3 {
			-webkit-animation-delay: -0.4s;
			animation-delay: -0.4s;
		}

		.container1 .circle4 {
			-webkit-animation-delay: -0.3s;
			animation-delay: -0.3s;
		}

		.container2 .circle4 {
			-webkit-animation-delay: -0.2s;
			animation-delay: -0.2s;
		}

		.container3 .circle4 {
			-webkit-animation-delay: -0.1s;
			animation-delay: -0.1s;
		}

		@-webkit-keyframes bouncedelay {
			0%, 80%, 100% { -webkit-transform: scale(0.0) }
			40% { -webkit-transform: scale(1.0) }
		}

		@keyframes bouncedelay {
			0%, 80%, 100% {
				transform: scale(0.0);
				-webkit-transform: scale(0.0);
			} 40% {
				transform: scale(1.0);
				-webkit-transform: scale(1.0);
			}
		}
	}
</style>



// WEBPACK FOOTER //
// Index.vue?2f41cff7